<div class="screen">

    <!-- HEADER -->
    <div class="header">
    </div>
  
    <!-- HERO SECTION -->
    <div class="hero">
  
      <div class="circle">
  
        <img
          src="assets/blocked-wallet.png"
          class="illustration"
          alt="warning"
        />
  
      </div>
  
    </div>
  
    <!-- TEXT -->
    <div class="text-block">
      <div class="title">Limit reached</div>
  
      <div class="subtitle">
        Add money to your wallet to pay for this transaction and any related fees.
      </div>
    </div>
  
    <!-- BUTTON -->
    
    <footer class="screen-footer">
      <button
        pButton
        label="CLOSE"
        class="retry-btn"
        (click)="retry()"
      ></button>
  
    </footer> 
    
  </div>
  ``